import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import EmbedModes from './pdf-embed/embed-modes.md';
import Annotations from './pdf-embed/annotations.md';
import PDFAnalytics from './pdf-embed/pdf-Analytics';
import Collaborative from './pdf-embed/collaborative-settings.md';
import SaveControls from './pdf-embed/save-controls.md';
import MenuTool from './pdf-embed/menu-tool-options';
import UseCase from './pdf-embed/use-case.md';
import StartEmbedding from './pdf-embed/start-embedding.md';
import WhyPdfEmbed from './pdf-embed/why-pdf-embed.md';
import KeyFeatures from './pdf-embed/key-features.md';
import ExploreAdobe from './pdf-embed/explore-adobe.md';
import Integration from './pdf-embed/integration.md';
import { APIPixelRetargeting } from '../../components/retargetting';
import { NewsLetterBlade } from '../../components/news-letter-blade';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const WrapperComponent = makeShortcode("WrapperComponent");
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const TabsBlock = makeShortcode("TabsBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading, text, assetsImg, buttons" customLayout variant="fullwidth" className="herobgImage Hero-Banner" mdxType="Hero" />
    <h1 {...{
      "id": "adobe-pdf-embed-api"
    }}>{`Adobe PDF Embed API`}</h1>
    <p>{`Free JavaScript API to embed high-fidelity PDFs, enable collaboration, and see analytics.`}</p>
    <p>{`apiHeroAssetImg doc-embed-hero`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/view-sdk-demo/index.html"
        }}>{`Try the demo`}</a></li>
    </ul>
    <WrapperComponent slots="content" theme="light" className="WhyPdfEmbed" mdxType="WrapperComponent" />
    <WhyPdfEmbed mdxType="WhyPdfEmbed" />
    <DCSummaryBlock slots="heading, buttons" background="rgb(31, 42, 73)" buttonPositionRight variantsTypePrimary='secondary' variantStyleFill='outline' className="embed-key-features" mdxType="DCSummaryBlock" />
    <h3 {...{
      "id": "key-features-of-our-free-pdf-embed-api"
    }}>{`Key features of our free PDF Embed API`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-embed-api"
        }}>{`Get free credentials`}</a></li>
    </ul>
    <TabsBlock orientation="vertical" slots="heading, image, content" repeat="6" theme="dark" className='bgBlue code-block-0 embed-key-features embed-key-features-code-block tabBlockAlign' mdxType="TabsBlock" />
    <h3 {...{
      "id": "embed-modes"
    }}>{`Embed Modes`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/b5b349278e9a18b17fc1c19af30f9795/embed.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <EmbedModes mdxType="EmbedModes" />
    <h3 {...{
      "id": "annotation"
    }}>{`Annotation`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/5c7ae487ff1bb992178f050d685f5dcd/annotations.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <Annotations mdxType="Annotations" />
    <h3 {...{
      "id": "pdf-analytics"
    }}>{`PDF Analytics`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/45dc7c84f56205d4373eabfc4272f49b/analytics-green.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <PDFAnalytics mdxType="PDFAnalytics" />
    <h3 {...{
      "id": "collaborative-settings"
    }}>{`Collaborative Settings`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/197d294182ba5702c2ee0e9cdc566054/collaborative_settings.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <Collaborative mdxType="Collaborative" />
    <h3 {...{
      "id": "save-controls"
    }}>{`Save Controls`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/fbb778deb13341213ef7f890eda09130/save_control.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <SaveControls mdxType="SaveControls" />
    <h3 {...{
      "id": "menu--tool-options"
    }}>{`Menu & Tool Options`}</h3>
    <p><img parentName="p" {...{
        "src": "/document-services/assets/f05e1b3f8c2c2508684e875d5a973f03/menu_tool_options.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <MenuTool mdxType="MenuTool" />
    <WrapperComponent slots="content" theme="lightest" className="integration-with-adobe" mdxType="WrapperComponent" />
    <Integration mdxType="Integration" />
    <WrapperComponent slots="content" theme="light" className="start-modifying-pdf" mdxType="WrapperComponent" />
    <StartEmbedding mdxType="StartEmbedding" />
    <WrapperComponent slots="content" theme="lightest" className="Use-cases-for-PDF-services-API" mdxType="WrapperComponent" />
    <UseCase mdxType="UseCase" />
    <TextBlock slots="buttons" isCentered theme="lightest" className='padding-5 Use-cases-for-PDF-services-API' mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/use-cases/agreements-and-contracts/sales-proposals-and-contracts/"
        }}>{`View all use cases`}</a></li>
    </ul>
    <WrapperComponent slots="content" theme="light" className="other-Adobe-Document-Services-APIs" mdxType="WrapperComponent" />
    <ExploreAdobe mdxType="ExploreAdobe" />
    <NewsLetterBlade className="news-letter" mdxType="NewsLetterBlade" />
    <DCSummaryBlock slots="heading, text, buttons" theme="lightest" background="white" className="How-to-get-started" mdxType="DCSummaryBlock" />
    <h3 {...{
      "id": "were-ready-to-help"
    }}>{`We're ready to help`}</h3>
    <p>{`Have questions about the Acrobat Services APIs?`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/pdftoolsapi_forum"
        }}>{`Go to the Adobe Forum`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../pricing/contact.md"
        }}>{`Contact us`}</a></li>
    </ul>
    <APIPixelRetargeting mdxType="APIPixelRetargeting" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      